export default __webpack_public_path__ + "static/media/amh.8f9b5920.jpeg";